import React from 'react';
import NavBar from '../../components/navBar/NavBar';
import './Main.scss';

const lazadaIcon = `${process.env.PUBLIC_URL}/assets/icons/lazada.png`;
const shopeeIcon = `${process.env.PUBLIC_URL}/assets/icons/shopee.png`;

export default function Main() {
  return (
    <div className="main">
      <NavBar name="Main" />

      {/* Hero -------------------------------------------------- */}
      <section className="hero">
        <h1 className="hero__title">
          ยินดีต้อนรับสู่เว็บไซต์ของเรา
          <small>กด Wholesale เพื่อตรวจสอบสินค้า หรือ Contact เพื่อติดต่อเรา</small>
        </h1>

        {/* marketplace buttons */}
        <div className="buy-icons">
          <a
            href="https://www.lazada.co.th/shop/atrobot"
            aria-label="Buy on Lazada"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={lazadaIcon} alt="Lazada" loading="lazy" />
            <span>Lazada</span>
          </a>

          <a
            href="https://shopee.co.th/atrobot228"
            aria-label="Buy on Shopee"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={shopeeIcon} alt="Shopee" loading="lazy" />
            <span>Shopee</span>
          </a>
        </div>
      </section>
    </div>
  );
}
